import React from 'react';
import PropTypes from 'prop-types';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../sessionStorage';
import Testimonials from './Testimonials';

export default function TestimonialPanel(props) {

    const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    const isTestimonialPanelEnable = accountObj && accountObj.account && accountObj.account.isTestimonialPanelEnable;

    return (
        isTestimonialPanelEnable && <div className='mt-3'><Testimonials styleType={props.styleType} /></div>
    );
}

TestimonialPanel.propTypes = {
    styleType: PropTypes.string,
}
